import { Navigate, useLocation, useParams } from 'react-router-dom';
import type { CanvasView } from '../../types';

/**
 * Back-compat redirect for the pre-migration catalog route segments (SC-2670).
 * The canvas views moved from `/table`/`/changes` to the generic, stable view
 * ids `/entities`/`/history`; this forwards an old deep link / bookmark /
 * dashboard CTA to the renamed segment under the same catalog. It preserves the
 * query string + hash (e.g. `?scope=`, a drawer `#anchor`) and `replace`s so the
 * retired URL doesn't linger in the history stack.
 */
export function SectionRedirect({ view }: { view: CanvasView }) {
  const { id = '' } = useParams<{ id: string }>();
  const { search, hash } = useLocation();
  return <Navigate to={`/catalogs/${id}/${view}${search}${hash}`} replace />;
}
